
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.392","height":"12.674"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Grupo 376"}},[_c('path',{attrs:{"data-name":"Rectángulo 617","fill":"#f1f1f1","d":"M.619.619h17.153v11.435H.619z"}}),_c('path',{attrs:{"data-name":"Rectángulo 617 - Contorno","d":"M.619 0h17.153a.619.619 0 01.619.619V12.05a.619.619 0 01-.619.619H.619A.619.619 0 010 12.05V.619A.619.619 0 01.619 0zM17.15 1.239H1.239v10.2H17.15z","fill":"#c6c6c6"}}),_c('path',{attrs:{"data-name":"Trazado 180","d":"M.619.619l8.617 8.67 8.535-8.67z","fill":"#fff"}}),_c('path',{attrs:{"data-name":"Trazado 180 - Contorno","d":"M.619 0h17.152a.619.619 0 01.571.38.619.619 0 01-.13.674l-8.535 8.67a.62.62 0 01-.44.185.619.619 0 01-.439-.183L.181 1.056A.618.618 0 01.049.381.619.619 0 01.619 0zm15.673 1.239H2.107l7.126 7.17z","fill":"#c6c6c6"}}),_c('path',{attrs:{"data-name":"Línea 64","d":"M11.101 4.574H7.289a.619.619 0 01-.619-.62.619.619 0 01.619-.619h3.812a.619.619 0 01.619.619.619.619 0 01-.619.62z","fill":"#c6c6c6"}})])])
          )
        }
      }
    